var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "duplicate-step1" },
    [
      _c(
        "div",
        {
          staticClass:
            "project-modal edit-deliverable-modal edit-project-modal duplicate-preview",
          attrs: { id: "edit__project__modal" }
        },
        [
          _c(
            "div",
            { staticClass: "project--top--section duplication-wizard" },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-8 d-flex left--side" },
                  [
                    _c("div", { staticClass: "project--page--title" }, [
                      _c("div", { staticClass: "text--section" }, [
                        _c(
                          "div",
                          { staticClass: "project--department--wrap" },
                          [
                            _c("ProjectDepartments", {
                              attrs: {
                                deliverable: _vm.sourceProject,
                                "is-duplication": true
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("label", { staticClass: "mb-0 w-100" }, [
                          _c(
                            "h1",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.editTitle,
                                  expression: "!editTitle"
                                }
                              ],
                              staticClass:
                                "mb-0 exclude-outside-click edit-d-title project-title",
                              staticStyle: { "line-height": "1" },
                              on: { click: _vm.activateTitleField }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.newTitle || "Click to set...") +
                                  "\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "click-outside",
                                rawName: "v-click-outside",
                                value: _vm.deactivateTitleField,
                                expression: "deactivateTitleField"
                              },
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.editTitle,
                                expression: "editTitle"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newTitle,
                                expression: "newTitle"
                              }
                            ],
                            ref: "projectTitle",
                            staticClass:
                              "form-control mb-3 title-field exclude-outside-click h1",
                            attrs: {
                              type: "text",
                              placeholder: "New project title..."
                            },
                            domProps: { value: _vm.newTitle },
                            on: {
                              blur: function($event) {
                                _vm.editTitle = false
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.newTitle = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.nameValidationState === false
                            ? _c(
                                "div",
                                { staticClass: "text-danger small mt-1" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        !_vm.newTitle.trim()
                                          ? "Project name is required"
                                          : "A project with this name already exists"
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "project-number" }, [
                          _c("span", [
                            _vm._v(
                              "Project Number: " +
                                _vm._s(_vm.sourceProject.project_number)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "project-due-date" }, [
                          _vm._v(
                            "\n                    Deadline:\n                    "
                          ),
                          _c(
                            "span",
                            { staticClass: "editable-project-due-date" },
                            [
                              _c(
                                "datepicker",
                                {
                                  attrs: { placeholder: "No Date" },
                                  on: {
                                    selected: function($event) {
                                      _vm.editDeadline = false
                                    }
                                  },
                                  model: {
                                    value: _vm.sourceProject.due_date,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.sourceProject,
                                        "due_date",
                                        $$v
                                      )
                                    },
                                    expression: "sourceProject.due_date"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "calender-header",
                                      attrs: { slot: "beforeCalendarHeader" },
                                      slot: "beforeCalendarHeader"
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "remove-dl-btn",
                                          attrs: { variant: "text" },
                                          on: {
                                            click: function($event) {
                                              _vm.sourceProject.due_date = null
                                            }
                                          }
                                        },
                                        [_vm._v("Remove Deadline")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "today-btn",
                                          attrs: { variant: "text" },
                                          on: {
                                            click: function($event) {
                                              _vm.sourceProject.due_date = new Date()
                                                .toISOString()
                                                .slice(0, 10)
                                            }
                                          }
                                        },
                                        [_vm._v("Today")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.projectDeliverables && _vm.projectDeliverables.length
                      ? _c("div", { staticClass: "project--milestones" }, [
                          _c("label", { staticClass: "field-label" }, [
                            _vm._v("PROJECT MILESTONES")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "project--milestones-wrap" },
                            _vm._l(_vm.projectDeliverables.length, function(
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: "ms-" + index,
                                  staticClass: "milestone",
                                  class: {
                                    active:
                                      _vm.projectDeliverables[index - 1]
                                        .is_complete == 1,
                                    dots:
                                      index <= _vm.projectDeliverables.length
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "milestone--full--deliverable"
                                    },
                                    [_vm._v(" ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "milestone--task--expanson"
                                    },
                                    _vm._l(
                                      _vm.projectDeliverables[index - 1].tasks
                                        .length,
                                      function(index1) {
                                        return _c(
                                          "span",
                                          {
                                            key:
                                              "ms-task-" + index + "-" + index1,
                                            style: {
                                              backgroundColor: _vm.tryJSONParse(
                                                _vm.getFieldJson(
                                                  _vm.projectDeliverables[
                                                    index - 1
                                                  ].tasks[index1 - 1]
                                                    .taskFields,
                                                  "status"
                                                ).value
                                              ).color
                                            }
                                          },
                                          [_vm._v(" ")]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dates" }, [
                            _c("span", { staticClass: "left" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.sourceProject.start_date,
                                    "MMMM DD, YYYY"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.sourceProject.due_date,
                                    "MMMM DD, YYYY"
                                  )
                                )
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.projectDetailFields, function(field, index) {
                      return _c(
                        "div",
                        {
                          key: "prj__detail__" + index,
                          staticClass: "field-box project--detail--field"
                        },
                        [
                          _c("ProjectCustomFields", {
                            attrs: {
                              deliverable: _vm.sourceProject,
                              customField: field,
                              "is-duplication": true
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "project--resources" }, [
                      _c(
                        "div",
                        { staticClass: "dropdown project--resources--title" },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "add-resource-button exclude-outside-click d-inline-block",
                              attrs: {
                                title: "Add resource",
                                id: "add-resource-button",
                                "data-toggle": "dropdown",
                                "aria-expanded": "false"
                              }
                            },
                            [_vm._v("Resources")]
                          ),
                          _vm._v(" "),
                          _c("plus-button", {
                            attrs: {
                              "data-toggle": "dropdown",
                              "aria-expanded": "false",
                              "data-reference": "parent"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "dropdown-menu project--resources--type--menu"
                            },
                            _vm._l(_vm.optionsForLinkType, function(type, i) {
                              return _c(
                                "a",
                                {
                                  key: i,
                                  staticClass: "dropdown-item",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      return _vm.addResourceMenuItemClick(
                                        type,
                                        $event
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass: "link-type-icon",
                                    attrs: {
                                      src: require("@/csmworkflow/img/" +
                                        type.icon)
                                    }
                                  }),
                                  _vm._v(" " + _vm._s(type.name))
                                ]
                              )
                            }),
                            0
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { class: _vm.getProjectResourcesClass },
                        _vm._l(_vm.resourceFields, function(resource, index) {
                          return _vm.showResourceBox(
                            resource.value,
                            resource.pfv_id
                          )
                            ? _c(
                                "div",
                                {
                                  key: "link_url-" + index,
                                  staticClass:
                                    "resource-entry resource-box editable"
                                },
                                [
                                  _c("img", {
                                    staticClass: "link-type-icon",
                                    attrs: {
                                      src: require("@/csmworkflow/img/" +
                                        _vm.getLinkTypeObject(
                                          _vm.customChildFieldValue(
                                            "link_type",
                                            resource.pfv_id
                                          )
                                        ).icon),
                                      draggable: "false"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "resource-box__url"
                                  }),
                                  _vm._v(" "),
                                  resource.value
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "resource-link",
                                          attrs: {
                                            href: resource.value,
                                            target: "_blank",
                                            id: "project-resource-" + index
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.customChildFieldValue(
                                                "link_label",
                                                resource.pfv_id
                                              ) || resource.value
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !resource.value
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "resource-link",
                                          attrs: {
                                            href: _vm.getResourceHref(
                                              resource.value,
                                              resource.pfv_id
                                            ),
                                            target: "_blank",
                                            id: "project-resource-" + index
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.customChildFieldValue(
                                                "link_label",
                                                resource.pfv_id
                                              ) || resource.value
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "edit-resource-btn",
                                      attrs: {
                                        title: "Edit resource",
                                        href: "#"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.editResource(resource)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fas fa-edit" })]
                                  ),
                                  _vm._v(" "),
                                  _vm.customChildFieldValue(
                                    "link_notes",
                                    resource.pfv_id
                                  )
                                    ? _c(
                                        "div",
                                        { staticClass: "resource-box__notes" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.customChildFieldValue(
                                                  "link_notes",
                                                  resource.pfv_id
                                                )
                                              )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      )
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4 right--side" }, [
                  _c(
                    "div",
                    { staticClass: "project-right-side-fields" },
                    [
                      _vm.sourceProject.engagement_manager &&
                      _vm.getSystemSetting("project__show_engagement_manager")
                        ? _c(
                            "div",
                            { staticClass: "field-box" },
                            [
                              _c("ProjectCustomFields", {
                                attrs: {
                                  deliverable: _vm.sourceProject,
                                  customField: {
                                    field_key: "engagement_manager",
                                    field_name: "engagement_manager",
                                    label: "Engagement Manager"
                                  },
                                  "is-duplication": true
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sourceProject.project_lead &&
                      typeof _vm.sourceProject.project_leaders == "undefined"
                        ? _c(
                            "div",
                            { staticClass: "field-box" },
                            [
                              _c("ProjectCustomFields", {
                                attrs: {
                                  deliverable: _vm.sourceProject,
                                  customField: {
                                    field_key: "project_lead",
                                    field_name: "project_lead",
                                    label:
                                      _vm.getSystemSetting(
                                        "project__project_lead_label"
                                      ) || "PROJECT LEAD"
                                  },
                                  "is-duplication": true
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      typeof _vm.sourceProject.project_leaders != "undefined"
                        ? _c(
                            "div",
                            { staticClass: "field-box" },
                            [
                              _c("ProjectCustomFields", {
                                attrs: {
                                  deliverable: _vm.sourceProject,
                                  customField: {
                                    field_key: "project_leaders",
                                    field_name: "project_leaders",
                                    label:
                                      _vm.getSystemSetting(
                                        "project__project_lead_label"
                                      ) || "PROJECT LEADERS"
                                  },
                                  "is-duplication": true
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.statusFields, function(field, index) {
                        return _c(
                          "div",
                          {
                            key: "prj__status__" + index,
                            staticClass: "field-box"
                          },
                          [
                            _c("ProjectCustomFields", {
                              attrs: {
                                deliverable: _vm.sourceProject,
                                customField: field,
                                "is-duplication": true
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.audienceFields, function(field, index) {
                        return _c(
                          "div",
                          {
                            key: "prj__audience__" + index,
                            staticClass: "field-box"
                          },
                          [
                            _c("ProjectCustomFields", {
                              attrs: {
                                deliverable: _vm.sourceProject,
                                customField: field,
                                "is-duplication": true
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.budgetFields, function(field, index) {
                        return _c(
                          "div",
                          {
                            key: "prj__budget__" + index,
                            staticClass: "field-box"
                          },
                          [
                            _c("ProjectCustomFields", {
                              attrs: {
                                deliverable: _vm.sourceProject,
                                customField: field,
                                "is-duplication": true
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.requisitionFields, function(field, index) {
                        return _c(
                          "div",
                          {
                            key: "prj__requisition__" + index,
                            staticClass: "field-box"
                          },
                          [
                            _c("ProjectCustomFields", {
                              attrs: {
                                deliverable: _vm.sourceProject,
                                customField: field,
                                "is-duplication": true
                              }
                            })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "hide-footer": "",
            id: "createProjectLinkModal",
            title: "New Resource / Link"
          },
          on: { shown: _vm.focusLinkModal }
        },
        [
          _c("CreateProjectLinkModal", {
            ref: "refLinkModal",
            attrs: {
              "link-url": _vm.linkUrl,
              "link-label": _vm.linkLabel,
              "link-notes": _vm.linkNotes,
              "link-type": _vm.linkType,
              "is-file": _vm.editLinkIsFile,
              "resource-parent": "project",
              "is-duplication": true
            },
            on: { "save-duplication-resource": _vm.saveDuplicationResource }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "hide-footer": "",
            id: "editProjectLinkModal",
            title: "Update Resource / Link"
          },
          on: { shown: _vm.focusEditLinkModal }
        },
        [
          _c("EditProjectLinkModal", {
            ref: "refEditLinkModal",
            attrs: {
              "link-url": _vm.linkUrl,
              "link-label": _vm.linkLabel,
              "link-notes": _vm.linkNotes,
              "link-type": _vm.linkType,
              "is-file": _vm.editLinkIsFile,
              "is-duplication": true
            },
            on: { "remove-duplication-resource": _vm.removeDuplicationResource }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }